<script>
    import { Pie } from "vue-chartjs";
    import DashboardService from "../../../services/Dashboard.service";
    import {alertResponseError} from "../../../helpers/general";
    export default {
        extends: Pie,
        data() {
            return {
                labels: [],
                bestAaccuracy: [],
                colors: [
                    "rgba(255, 0, 0, 0.25)",
                    "rgba(204, 51, 255, 0.25)",
                    "rgba(0, 102, 255, 0.25)",
                    "rgba(40, 120, 56, 0.25)",
                    "rgba(22, 220, 30, 0.25)",
                    "rgba(218, 159, 0, 0.25)",
                    "rgba(255, 231, 0, 0.25)"
                ]
            }
        },
        mounted() {
            this.getBestAccuracy();
        },
        methods: {
            getBestAccuracy() {
                return DashboardService.getBestAccuracy().then((response) => {
                    if (response.data.success) {
                        if (response.data.data) {
                            this.labels = response.data.data.map(item => item.label);
                            let data = response.data.data.map(item => item.model_count);
                            this.bestAaccuracy = data.reduce((a, b) => a + b, 0);
                            if (this.bestAaccuracy > 0) {
                                return this.showChart(data);
                            } else {
                                this.$emit('isShow', false);
                            }
                        } else {
                            return this.$emit('isShow', false);
                        }
                    }
                }).catch((error) => {
                    alertResponseError(error);
                });
            },
            showChart(data) {
                let gradients = [];
                let graphData = data.map((item) => {
                    return item/this.bestAaccuracy * 100;
                })
                for (let i = 0; i < this.labels.length; i++) {
                    gradients.push(this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 450));
                }
                for (let i = 0; i < this.labels.length; i++) {
                    gradients[i].addColorStop(0.5, `${this.colors[i % this.colors.length]}`);
                }
                this.renderChart(
                    {
                        labels: this.labels,
                        datasets: [
                            {
                                backgroundColor: gradients,
                                data: graphData
                            }
                        ]
                    },
                    { 
                        responsive: true, 
                        maintainAspectRatio: false,
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                                }
                            }
                        }
                    }
                );
            }
        }
    };
</script>